import React from "react";
import { Button } from "./ui/button";
import { ArrowRight, Zap, Clock, Target } from "lucide-react";
import "../App.css";

const Hero = () => {
    const scrollToPricing = () => {
        const element = document.getElementById("pricing");
        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
        }
    };

    const scrollToHowItWorks = () => {
        const element = document.getElementById("how-it-works");
        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <section className="relative bg-gradient-to-b from-slate-50 to-white hero-main-container">
            <div className="container mx-auto px-6">
                <div className="max-w-4xl mx-auto text-center">
                    {/* Badge */}
                    <div className="inline-flex items-center space-x-2 bg-slate-100 rounded-full px-4 py-2 mb-8">
                        <Zap className="w-4 h-4 text-slate-600" />
                        <span className="text-sm font-medium text-slate-600">
                            Drawing Automation SaaS
                        </span>
                    </div>

                    {/* Main Headline */}
                    <h1 className="text-4xl md:text-6xl font-bold text-slate-900 mb-3 leading-tight">
                        GenieFab: Automating
                        <span className="block text-transparent bg-clip-text bg-gradient-to-r from-slate-800 to-slate-600 h-[130px]">
                            Pressure Vessel Fabrication Drawings
                        </span>
                    </h1>

                    {/* Subheadline */}
                    <p className="text-xl md:text-2xl text-slate-600 mb-4 font-medium">
                        Faster. Flawless. Future-Ready.
                    </p>

                    {/* Description */}
                    <p className="text-lg text-slate-600 mb-12 max-w-3xl mx-auto leading-relaxed">
                        Welcome to GenieFab, your innovative SaaS solution
                        transforming how pressure vessel drawings are created.
                        Say goodbye to the multi-day grind of manual drafting.
                        With GenieFab, you can generate precise, ready-to-submit
                        pressure vessel drawings in{" "}
                        <strong>hours, not days</strong>.
                    </p>

                    {/* Stats Row */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
                        <div className="flex items-center justify-center space-x-3">
                            <Clock className="w-6 h-6 text-slate-700" />
                            <div className="text-left">
                                <div className="text-2xl font-bold text-slate-900">
                                    3-4 Days → Hours
                                </div>
                                <div className="text-sm text-slate-600">
                                    Dramatic Time Savings
                                </div>
                            </div>
                        </div>
                        <div className="flex items-center justify-center space-x-3">
                            <Target className="w-6 h-6 text-slate-700" />
                            <div className="text-left">
                                <div className="text-2xl font-bold text-slate-900">
                                    99%+ Accuracy
                                </div>
                                <div className="text-sm text-slate-600">
                                    Precision Engineering
                                </div>
                            </div>
                        </div>
                        <div className="flex items-center justify-center space-x-3">
                            <Zap className="w-6 h-6 text-slate-700" />
                            <div className="text-left">
                                <div className="text-2xl font-bold text-slate-900">
                                    5x Productivity
                                </div>
                                <div className="text-sm text-slate-600">
                                    Enhanced Workflow
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* CTA Buttons */}
                    <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4">
                        <Button
                            size="lg"
                            className="bg-slate-800 hover:bg-slate-700 text-white px-8 py-4 rounded-lg transition-all duration-200 transform hover:scale-105 shadow-lg hover:shadow-xl"
                            onClick={scrollToPricing}
                        >
                            Start Free Trial
                            <ArrowRight className="ml-2 w-4 h-4" />
                        </Button>
                        <Button
                            variant="outline"
                            size="lg"
                            className="border-2 border-slate-300 text-slate-700 hover:bg-slate-50 px-8 py-4 rounded-lg transition-all duration-200"
                            onClick={scrollToHowItWorks}
                        >
                            See How It Works
                        </Button>
                    </div>

                    {/* Trust Indicator */}
                    <p className="text-sm text-slate-500 mt-8">
                        Trusted by engineering teams worldwide • No credit card
                        required
                    </p>
                </div>
            </div>

            {/* Decorative Elements */}
            <div className="absolute top-20 left-10 w-20 h-20 bg-slate-100 rounded-full opacity-50 blur-xl"></div>
            <div className="absolute bottom-20 right-10 w-32 h-32 bg-slate-100 rounded-full opacity-30 blur-2xl"></div>
        </section>
    );
};

export default Hero;
